import { TemplateKey } from "PFApp/constants/templates";

import { useTemplate } from "../../../hooks";
import { useActivityFormStore } from "../activity_form_store";

export const useEngagementTemplate = () => {
  const { isAudit } = useActivityFormStore((state) => state.activityStatus);

  return useTemplate(isAudit ? TemplateKey.AuditEngagement : TemplateKey.Engagement);
};
